import React from 'react';

const PageMessage = ({ className, children }) => (
  <div className={`bg-white  ${className}`}>
    {children}
  </div>
);

PageMessage.defaultProps = {
  className: ''
};

export default PageMessage;
